import loadable from "@loadable/component"
import { Navigate, RouteObject } from "react-router-dom"

import { APP_ROUTES } from "~/shared/constants/routes"
import { useUserInfo } from "~/store/user/userSlice"

const IssuingSystemSettingsPage = loadable(
  async () =>
    import("~/features/issuing-system-settings/pages/IssuingSystemSettingsPage"),
  { fallback: <></> },
)

const SuperAdminIssuingSystemSettingsRoute = () => {
  const { user } = useUserInfo()
  return user?.user?.roles?.some((role) => String(role) === "SuperAdmin") ? (
    <IssuingSystemSettingsPage />
  ) : (
    <Navigate replace to={APP_ROUTES.home} />
  )
}

export const issuingSystemSettingsRoutes: RouteObject[] = [
  {
    path: APP_ROUTES.issuingSystemSettings,
    element: <SuperAdminIssuingSystemSettingsRoute />,
  },
]
